import React from "react";

import { getUtcTime } from "./utils";

export const NON_EDITABLE_FIELDS = [
  {
    fields: {
      npi_number: "NPI",
      caqh_providerid: "CAQH ID",
    },
    label: "Credentialing Request Details",
    value: "primary",
  },
];

export const CATEGORIES = [
  {
    label: "Primary Demographic",
    value: "primary",
  },
  {
    label: "Office",
    value: "office",
  },
  {
    label: "Board Certification",
    value: "board_certification",
  },
  {
    label: "State License",
    value: "state_lic",
  },
  {
    label: "DEA",
    value: "dea",
  },
  {
    label: "Education",
    value: "education",
  },
  {
    label: "Hospital",
    value: "hospital",
  },
  {
    label: "Insurance",
    value: "insurance",
  },
  {
    label: "Accreditation",
    value: "accreditation",
  },
  {
    label: "Work History",
    value: "work_history",
  },
  {
    label: "Notes",
    value: "notes",
  },
];

export const HISTORY_COLUMNS = [
  {
    dataIndex: "user",
    key: "user_name",
    title: "Author",
    width: 150,
    ellipsis: true,
    render: val => `${val?.first_name} ${val?.last_name}`,
    sorter: true,
  },
  {
    dataIndex: "user",
    key: "user_email",
    title: "Author Email",
    width: 200,
    ellipsis: true,
    render: val => `${val?.email}`,
    sorter: true,
  },
  {
    dataIndex: "item_type",
    key: "item_type",
    title: "Table",
    width: 200,
    ellipsis: true,
    sorter: true,
  },
  {
    dataIndex: "event",
    key: "event",
    title: "Action",
    width: 100,
    ellipsis: true,
    sorter: true,
  },
  {
    dataIndex: "change_diff",
    key: "change_diff",
    title: "Changes",
    width: 300,
    render: val => {
      const changesAsString = Object.entries(val)
        .map(
          ([column, changes]) =>
            `${column}: ${changes[0] || "Nil"} => ${changes[1] || "Nil"}`
        )
        .join("\n");

      const changes = changesAsString.split("\n");
      const changesHTML = changes.map((change, index) => (
        <div key={index}>
          <b>{change.split(":")[0]}</b>
          <i>:{change.split(":")[1]}</i>
        </div>
      ));

      return changesHTML;
    },
  },
  {
    dataIndex: "created_at",
    key: "created_at",
    title: "Action Time",
    width: 240,
    render: val => getUtcTime(val),
    sorter: true,
  },
];

export const NPI_RECORDS_LIST_COLUMNS = [
  {
    dataIndex: "npi_number",
    key: "npi_number",
    title: "NPI Number",
    width: 100,
    ellipsis: true,
    render: (_, rowData) => (
      <div className=" text-primary-shade">{rowData.npi_number}</div>
    ),
  },
  {
    dataIndex: "caqh_providerid",
    key: "caqh_providerid",
    title: "CAQH Provider ID",
    width: 100,
    ellipsis: true,
  },
  {
    dataIndex: "request_id",
    key: "request_id",
    title: "Request ID",
    width: 100,
    ellipsis: true,
  },
  {
    dataIndex: "rec_create_dt",
    key: "rec_create_dt",
    title: "Record Create Date",
    width: 200,
    ellipsis: true,
    render: val => getUtcTime(val),
  },
];

export const TABS_WITH_SINGLE_SUBTAB = ["primary", "notes"];
